import React, {useState} from 'react';
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import {word} from "../word.js";
import BlueButton from "./BlueButton/BlueButton.js";
import ErrorToast from "./BlueButton/ErrorToast.js";
import Api from "../Api.js";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 600 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '97vh'
};

function ResetPass({open, setOpen}) {
    const [mail, setMail] = useState('')
    const [code, setCode] = useState('')
    const [password, setPassword] = useState('')
    const [status, setStatus] = useState('')
    const handleResetRequest = async () => {
        try {
            await Api.passwordRequest({email: mail})
            setStatus('code')
        } catch (e) {
            console.log(e)
            ErrorToast(e?.response?.data?.message)
        }
    }
    const handleResetCode = async () => {
        try {
            await Api.passwordVerify({email: mail, code: code})
            setStatus('pass')
        } catch (e) {
            ErrorToast(e?.response?.data?.message)
        }
    }
    const handleResetPassword = async () => {
        try {
            await Api.passwordEnter({email: mail,code: code, password: password})
            setOpen('')
        } catch (e) {
            ErrorToast(e?.response?.data?.message)
        }
    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='d-flex w-100 justify-content-center'>
                        <div className="d-flex align-items-center flex-column">
                            <label style={{marginBottom: 30}}>
                                <input
                                    placeholder={word.email}
                                    className="login-input" type="mail" value={mail}
                                    onChange={(ev) => setMail(ev.target.value)}/>
                            </label>
                            {status === 'code' ? <label style={{marginBottom: 30}}>
                                <input
                                    placeholder="Մուտքագրեք հաստատման կոդը"
                                    className="login-input" value={code}
                                    onChange={(ev) => setCode(ev.target.value)}/>
                            </label> : null}
                            {status === 'pass' ? <label style={{marginBottom: 30}}>
                                <input
                                    placeholder="Մուտքագրեք նոր գաղտնաբառը"
                                    className="login-input" value={password}
                                    onChange={(ev) => setPassword(ev.target.value)}/>
                            </label> : null}
                            <div className="">
                                <BlueButton
                                    title="Հաստատել"
                                    onChangeValue={!status ? handleResetRequest : status === "code" ? handleResetCode :handleResetPassword}
                                />

                            </div>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default ResetPass;